/*
 * Strubbel ingredient chips.
 * Mouse: hovering (or keyboard focus) shows a small card next to the chip.
 * Touch: tapping opens a bottom sheet with the photo and the explanation
 * (close with ×, by tapping outside, Escape or swiping down).
 */
(function () {
  if (window.StrubbelZutaten) return;
  window.StrubbelZutaten = true;

  var mouse = window.matchMedia('(hover: hover) and (pointer: fine)');
  var pop, sheet, panel, lastTrigger, activeChip, closeTimer;
  var COLORS = { lime: 'Shampoo', blue: 'Conditioner', lilac: 'Haaröl' };

  function el(tag, cls, parent) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (parent) parent.appendChild(node);
    return node;
  }

  function content(parent) {
    var media = el('div', 'sb-zutat__media', parent);
    var img = el('img', 'sb-zutat__img', media);
    img.alt = '';
    img.decoding = 'async';
    img.width = 800;
    img.height = 500;
    var title = el('p', 'sb-zutat__title', parent);
    var text = el('p', 'sb-zutat__text', parent);
    var found = el('p', 'sb-zutat__in', parent);
    return { media: media, img: img, title: title, text: text, found: found };
  }

  function build() {
    if (pop) return;
    pop = el('div', 'sb-zutat-pop', document.body);
    pop.setAttribute('role', 'tooltip');
    pop.id = 'SbZutatPop';
    pop.hidden = true;
    pop.parts = content(pop);

    sheet = el('div', 'sb-zutat-sheet', document.body);
    sheet.hidden = true;
    var backdrop = el('div', 'sb-zutat-sheet__backdrop', sheet);
    backdrop.addEventListener('click', closeSheet);
    panel = el('div', 'sb-zutat-sheet__panel', sheet);
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    el('span', 'sb-zutat-sheet__handle', panel);
    var close = el('button', 'sb-zutat-sheet__close', panel);
    close.type = 'button';
    close.setAttribute('aria-label', 'Schließen');
    close.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    close.addEventListener('click', closeSheet);
    panel.parts = content(panel);
    panel.parts.title.id = 'SbZutatSheetTitle';
    panel.setAttribute('aria-labelledby', 'SbZutatSheetTitle');
    swipeToClose(panel);
  }

  function fill(parts, chip) {
    var src = chip.dataset.img;
    parts.media.hidden = !src;
    if (src && parts.img.getAttribute('src') !== src) {
      parts.img.classList.remove('is-loaded');
      parts.img.onload = function () { parts.img.classList.add('is-loaded'); };
      parts.img.src = src;
    }
    parts.title.textContent = chip.dataset.title || '';
    parts.text.textContent = chip.dataset.desc || '';
    parts.found.innerHTML = '';
    var list = (chip.dataset.in || '').split('|').filter(Boolean);
    if (list.length) {
      el('span', 'sb-zutat__in-label', parts.found).textContent = 'Steckt in:';
      list.forEach(function (entry) {
        var bits = entry.split(':');
        var tag = el('span', 'sb-zutat__tag sb-zutat__tag--' + bits[0], parts.found);
        tag.textContent = bits.slice(1).join(':') || COLORS[bits[0]] || '';
      });
    }
    parts.found.hidden = !list.length;
  }

  function setActive(chip) {
    if (activeChip && activeChip !== chip) activeChip.classList.remove('is-active');
    activeChip = chip;
    if (chip) chip.classList.add('is-active');
  }

  /* ---------- mouse: small card next to the chip ---------- */
  function showPop(chip) {
    build();
    clearTimeout(closeTimer);
    fill(pop.parts, chip);
    pop.hidden = false;
    chip.setAttribute('aria-describedby', pop.id);
    var r = chip.getBoundingClientRect();
    var w = pop.offsetWidth;
    var h = pop.offsetHeight;
    var left = Math.min(Math.max(12, r.left + r.width / 2 - w / 2), window.innerWidth - w - 12);
    var above = r.top - h - 14 > 8;
    var top = above ? r.top - h - 14 : r.bottom + 14;
    pop.style.left = left + 'px';
    pop.style.top = top + 'px';
    pop.style.setProperty('--sb-arrow-x', r.left + r.width / 2 - left + 'px');
    pop.classList.toggle('is-below', !above);
    requestAnimationFrame(function () { pop.classList.add('is-visible'); });
    setActive(chip);
  }

  function hidePop() {
    if (!pop) return;
    pop.classList.remove('is-visible');
    closeTimer = setTimeout(function () { pop.hidden = true; }, 160);
    if (activeChip) activeChip.removeAttribute('aria-describedby');
    setActive(null);
  }

  /* ---------- touch: bottom sheet ---------- */
  function openSheet(chip) {
    build();
    fill(panel.parts, chip);
    lastTrigger = chip;
    sheet.hidden = false;
    panel.style.transform = '';
    document.documentElement.classList.add('sb-zutat-open');
    requestAnimationFrame(function () {
      sheet.classList.add('is-open');
      panel.querySelector('.sb-zutat-sheet__close').focus({ preventScroll: true });
    });
    setActive(chip);
  }

  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    panel.style.transform = '';
    document.documentElement.classList.remove('sb-zutat-open');
    setTimeout(function () { sheet.hidden = true; }, 280);
    setActive(null);
    if (lastTrigger) lastTrigger.focus({ preventScroll: true });
  }

  function swipeToClose(target) {
    var startY = null;
    var dy = 0;
    target.addEventListener('touchstart', function (e) { startY = e.touches[0].clientY; dy = 0; target.style.transition = 'none'; }, { passive: true });
    target.addEventListener('touchmove', function (e) {
      if (startY === null) return;
      dy = Math.max(0, e.touches[0].clientY - startY);
      target.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    target.addEventListener('touchend', function () {
      target.style.transition = '';
      if (dy > 80) closeSheet();
      else target.style.transform = '';
      startY = null;
    });
  }

  /* ---------- events ---------- */
  document.addEventListener('mouseover', function (e) {
    if (!mouse.matches) return;
    var chip = e.target.closest && e.target.closest('[data-zutat]');
    if (chip && chip !== activeChip) showPop(chip);
  });
  document.addEventListener('mouseout', function (e) {
    if (!mouse.matches) return;
    var chip = e.target.closest && e.target.closest('[data-zutat]');
    if (chip && !chip.contains(e.relatedTarget)) hidePop();
  });
  document.addEventListener('focusin', function (e) {
    var chip = e.target.closest && e.target.closest('[data-zutat]');
    if (chip && mouse.matches) showPop(chip);
  });
  document.addEventListener('focusout', function (e) {
    var chip = e.target.closest && e.target.closest('[data-zutat]');
    if (chip && mouse.matches) hidePop();
  });
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-zutat]');
    if (!chip) return;
    e.preventDefault();
    if (mouse.matches) showPop(chip);
    else openSheet(chip);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeSheet();
    hidePop();
  });
  window.addEventListener('scroll', function () { if (pop && !pop.hidden) hidePop(); }, { passive: true });
})();
